<div class="voxel-container-md recaptcha-error-header" [ngClass]="headerClass">
    <div class="portal-header-link">
        <button voxelButtonAction (click)="closeApp()">
            {{closeText}}
        </button>
        <voxel-icon type="secondary" (click)="closeApp()" class="ico">fechar</voxel-icon>
    </div>
</div>

<div class="voxel-container-md recaptcha-error-content">

    <voxel-icon size="L" a11yHidden="false" [a11yLabel]="closeText" type="primary" class="icon">
        {{icon}}
    </voxel-icon>

    <h1 class="title">
        {{title}}
    </h1>

    <p class="subtitle">{{subtitle}}</p>

    <button voxelButton class="voxel-col-12 voxel-col-sm-12 voxel-col-md-12 action-button" (click)="closeApp()">
        {{textButton}}
    </button>

</div>